export const MEDIA_TYPES_ALL = [
  { value: 'tv', label: 'TV' },
  { value: 'radio', label: 'Rádio' },
  { value: 'impresso', label: 'Impresso' },
  { value: 'site', label: 'Site' },
  { value: 'blog', label: 'Blog' },
];